import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, SectionLabel } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?client=ms-android-samsung-ss&hs=iY5V&sca_esv=9ab0a0c6eae9b82c&biw=360&bih=699&sxsrf=APpeQnvIzZkzmgN3PS-jd3UmvZgaCyVZYw:1791163916784&q=avis+sur+janzu&uds=AJ5uw1_a2D0D09lxm8gpKKOTUn4rWRj0JkcTRbZH5plbEXqzqzYqIEmXEZtvbScixZ2rNj_svQIfdnWnZbi_xPe6nqenMUeHOSrruoZMzLcF4YhEei7iA8WMBB9PqFn-PVyUqOJ8TQKIngsDMH9bMagQcc8FMhpXgyqObkeL7Jmpg6N9BaYEDMAPyeBR5S0NdFR1oA1xELQiezFenfmzCqOXH2Zdo4GZRk3D8OL4_4m4G40yj0HwW7d5OOc6dJBcwrEjAE6nmK5C-sK4ncvrrIQg647lnzRRbTdy6d5KFePIpGnJ6lmv6vTMeXqsIL48Ca7IgzpJ2XJUilLoR9GyyTAdICwebn4SG_csN9ziWxT69WybNt3dz6cpLlcZWtLHsTwH1JKLPkRIEh7dQpELXhGYEwTzU6aOFJl0rzfZIBMpYBK6q4yVKTA&si=APenkKm7iecQ4G6P-TsbSMFKIQtv3EFIqRAFw-i8uEbk55Z-_7bPiBiuHwJL98C3zmFjM6X8TGgxIaVbYNA1IZpDfM2NsmJtLWWQjbWEXjevvq_l0xG0lQC4oNhyDotwQjUiwvnatZXN&sa=X&ved=2ahUKEwij7PnH3aGXAxW68LsIHa5AB1kQxKsJKAB6BAgOEAE&ictx=1&stq=1&cs=1&lei=DP7CaqO2L7rh7_UProGdyAU";

const TESTIMONIALS = [
  {
    q: "J'ai suivi la formation de l'École française de Janzu et la pratique du Janzu® a véritablement apporté une nouvelle dimension dans ma vie, ainsi qu'auprès des personnes que j'accompagne dans l'eau. Une formation complète, suivie, avec de véritables outils pédagogiques, qui nous accompagne pas à pas jusqu'au métier de praticien.",
    n: "Galoup (Gaëlle)",
    r: "Praticienne — Île de la Réunion",
    p: "/media/temoignage-gaelle.jpg",
  },
  {
    q: "I highly recommend to do the Janzu training course with this school !!! A very profound experience to discover the magical power of Janzu. I believe everyone should at least try it once to feel the benefits of water healing therapy.",
    n: "Jean-Paul",
    r: "Praticien — Île Maurice",
    p: "/media/temoignage-jeanpaul.jpg",
  },
  {
    q: "Cette formation est un délice de découverte de soi et de l'autre. La formation est distillée par Stéphanie avec tact, précisions, grande spontanéité. Tout est senti ! Tout est vécu ! Rien n'est au hasard dans une grande simplicité et liberté. J'aime bcp cet enseignement. Merci Stéphanie. Merci l'école OJanzu.",
    n: "Edith",
    r: "Praticienne — France",
    p: "/media/temoignage-edith.jpg",
  },
  {
    q: "Formation dans la douceur et l'accompagnement. Stéphanie facilite chez chacun l'expression des techniques et des principes du Janzu. Merci à toi.",
    n: "Jérôme",
    r: "Praticien — France",
    p: "/media/temoignage-jerome.jpg",
  },
];

function GoogleIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path fill="#4285F4" d="M23.5 12.3c0-.9-.1-1.5-.3-2.2H12v4.1h6.5c-.1 1.1-.9 2.8-2.5 3.9l3.8 2.9c2.3-2.1 3.7-5.2 3.7-8.7z" />
      <path fill="#34A853" d="M12 24c3.2 0 6-1.1 7.9-2.9l-3.8-2.9c-1 .7-2.4 1.2-4.1 1.2-3.2 0-5.9-2.1-6.8-5h-4v3C3.2 21.3 7.3 24 12 24z" />
      <path fill="#FBBC05" d="M5.2 14.4c-.3-.7-.4-1.5-.4-2.4s.2-1.7.4-2.4v-3h-4C.4 8.2 0 10.1 0 12s.4 3.8 1.2 5.4l4-3z" />
      <path fill="#EA4335" d="M12 4.8c2.3 0 3.8 1 4.7 1.8l3.4-3.3C18 1.2 15.2 0 12 0 7.3 0 3.2 2.7 1.2 6.6l4 3c.9-2.9 3.6-4.8 6.8-4.8z" />
    </svg>
  );
}

export default function Temoignages() {
  const { tr } = useLang();
  return (
    <main className="min-h-screen bg-abyss pt-[72px] pb-24" data-testid="temoignages-page">
      <div className="mx-auto max-w-7xl px-5 pt-14 md:px-10">
        <Reveal>
          <SectionLabel>{tr("Témoignages")}</SectionLabel>
          <h1 className="mt-5 max-w-2xl font-serif text-4xl md:text-5xl font-light leading-tight text-foam">
            {tr("Paroles de la communauté")}
          </h1>
          <p className="mt-5 max-w-xl text-sm text-foam/60">
            {tr("Les retours de celles et ceux qui ont suivi le cursus praticien OJANZU — et le reportage TF1 qui leur est consacré.")}
          </p>
        </Reveal>

        <Reveal delay={0.08}>
          <h2 className="mt-14 text-center font-serif text-3xl md:text-4xl text-foam" data-testid="temoignages-video-title">
            {tr("Ils témoignent en vidéo")}
          </h2>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="glass-card mt-10 overflow-hidden rounded-2xl" data-testid="instagram-reel-card">
            <div className="grid md:grid-cols-[340px_1fr]">
              <iframe
                src="https://www.instagram.com/reel/DbPyWF3TMSM/embed"
                title="Témoignage vidéo Instagram — OJANZU"
                allowFullScreen
                scrolling="no"
                allow="encrypted-media"
                className="h-[480px] w-full border-0 md:h-full md:min-h-[480px]"
              />
              <div className="flex flex-col justify-center p-8">
                <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-aqua">{tr("Témoignage vidéo — Instagram")}</p>
                <p className="mt-4 font-serif text-2xl md:text-3xl text-foam">{tr("La magie de l'eau, en images.")}</p>
                <p className="mt-3 text-sm leading-relaxed text-foam/60">
                  {tr("Un instant de séance partagé sur notre Instagram : l'eau qui porte, le lâcher-prise, la présence. Suivez @ojanzu pour vivre le quotidien de l'école.")}
                </p>
                <a
                  href="https://www.instagram.com/reel/DbPyWF3TMSM/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="instagram-reel-link"
                  className="mt-6 inline-flex w-fit items-center gap-2 rounded-full border border-aqua/40 px-6 py-3 text-sm font-medium text-aqua transition-all duration-300 hover:bg-aqua hover:text-abyss"
                >
                  {tr("Voir le réel sur Instagram")}
                  <ArrowRight size={15} />
                </a>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <h2 className="mt-16 text-center font-serif text-3xl md:text-4xl text-foam" data-testid="podcast-section-title">
            {tr("Podcast")}
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-center text-sm text-foam/55">
            {tr("Stéphanie est l'invitée de « Dans l'Intimité du Vivant » — un épisode pour ouvrir la magie de l'eau, à l'ombre d'un arbre.")}
          </p>
          <div className="glass-card mx-auto mt-8 max-w-3xl rounded-2xl p-6 md:p-8" data-testid="podcast-card">
            <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-aqua">
              {tr("Épisode 16 · Rencontre avec Stéphanie — La magie de l'eau")}
            </p>
            <iframe
              src="https://player.ausha.co?podcastId=A8zWNCpx7z6g&display=horizontal&color=38bdf8&v=2"
              title="Podcast Dans l'Intimité du Vivant — lecteur Ausha"
              frameBorder="0"
              loading="lazy"
              allow="autoplay"
              className="mt-5 h-[200px] w-full rounded-xl"
            />
            <p className="mt-4 flex flex-wrap gap-x-6 gap-y-1 font-mono text-[11px] uppercase tracking-[0.18em] text-foam/45">
              <a
                href="https://podcast.ausha.co/dans-l-intimite-du-vivant/16-rencontre-avec-stephanie-la-magie-de-l-eau"
                target="_blank"
                rel="noreferrer"
                className="text-aqua transition-colors hover:text-foam"
                data-testid="podcast-episode-link"
              >
                {tr("Écouter l'épisode sur Ausha")}
              </a>
              <a href="https://podcasts.apple.com/fr/podcast/dans-l-intimite-du-vivant/id1825331563" target="_blank" rel="noreferrer" className="transition-colors hover:text-aqua">
                Apple Podcasts
              </a>
              <a href="https://open.spotify.com/show/7LSGa3BqDRaMA0rNwxaI5z" target="_blank" rel="noreferrer" className="transition-colors hover:text-aqua">
                Spotify
              </a>
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <a
            href={GOOGLE_REVIEWS_URL}
            target="_blank"
            rel="noreferrer"
            data-testid="google-reviews-card"
            className="glass-card group mt-16 flex items-center justify-between gap-6 rounded-2xl p-7 transition-all duration-300 hover:border-aqua/40"
          >
            <span className="flex items-center gap-5">
              <span className="grid h-12 w-12 shrink-0 place-items-center rounded-full bg-foam/95">
                <GoogleIcon />
              </span>
              <span>
                <span className="block font-serif text-xl text-foam">{tr("Retrouvez tous nos avis Google")}</span>
                <span className="mt-1 block text-xs text-foam/55">
                  {tr("La confiance de nos stagiaires se lit aussi dans leurs avis Google — cliquez pour les découvrir.")}
                </span>
              </span>
            </span>
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-aqua transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </a>
        </Reveal>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4" data-testid="text-testimonials">
          {TESTIMONIALS.map((t, i) => (
            <Reveal key={t.n} delay={0.08 * i}>
              <figure className="glass-card flex h-full flex-col justify-between rounded-2xl p-7" data-testid={`temoignage-card-${i + 1}`}>
                <blockquote className="font-serif text-lg italic leading-snug text-foam/90">
                  « {t.q} »
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-3">
                  <img src={t.p} alt={`Témoignage de ${t.n}`} className="h-12 w-12 shrink-0 rounded-full object-cover" />
                  <span>
                    <span className="block font-mono text-xs uppercase tracking-[0.2em] text-aqua">{t.n}</span>
                    <span className="mt-1 block text-xs text-foam/50">{t.r}</span>
                  </span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <p className="mt-10 text-sm text-foam/50">
            {tr("Envie de voir leurs visages ? Le reportage TF1 vous attend dans")}{" "}
            <Link to="/presse" className="text-aqua underline-offset-4 hover:underline" data-testid="temoignages-presse-link">
              {tr("l'onglet Presse")}
            </Link>
            .
          </p>
        </Reveal>
      </div>
    </main>
  );
}